import React from "react";
import Alert from "@amzn/meridian/alert";
import { ALERT_DEFAULT_MESSAGE } from "../../constants";

export default function AlertErrorWithMessage({
  message = ALERT_DEFAULT_MESSAGE,
}) {
  return <Alert type="error">{message}</Alert>;
}
